import React from 'react';
import './GovFooterBar.css';
import { useTranslation } from 'react-i18next';

const GovFooterBar = () => {
  const { t } = useTranslation();

  return (
    <div className="GovFooterBar">
      <span className="GovFooterBarText">{t('govFooterBar.Gov')}</span>
      <a
        className="GovFooterBarLink"
        href="/portal/termos_e_condicoes_de_uso_pedea.pdf"
        target="_blank"
        rel="noreferrer"
      >
        {t('govFooterBar.terms')}
      </a>
      <a
        className="GovFooterBarLink"
        href="/portal/aviso_privacidade_pedea.pdf"
        target="_blank"
        rel="noreferrer"
      >
        {t('govFooterBar.privacy')}
      </a>
    </div>
  );
};

export default GovFooterBar;
